import * as React from 'react';
import { SVGProps } from 'react';

const IconPictureSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15 13.444V2.556C15 1.7 14.3 1 13.444 1H2.556C1.7 1 1 1.7 1 2.556v10.888C1 14.3 1.7 15 2.556 15h10.888C14.3 15 15 14.3 15 13.444ZM5.278 9.167l1.944 2.34L9.944 8l3.5 4.667H2.556l2.722-3.5Z" />
  </svg>
);
export default IconPictureSizeS;
